import styled, { css } from 'styled-components'
import { ButtonUnstyled } from '@sketch/components'

export const Sidebar = styled.div<{ restoreInitialWidth?: boolean }>`
  height: 100%;
  background: ${({ theme }) => theme.colors.background.secondary.B};
  position: relative;
  /* Prevent the canvas artboard names from showing on top of the sidebar */
  z-index: 1;

  /* Prevent the sidebar to have scrolling since the list will have it */
  overflow: hidden;

  ${({ restoreInitialWidth }) =>
    restoreInitialWidth &&
    css`
      transition-timing-function: ease-in-out;
      transition-duration: 0.3s;
      transition-property: width;
    `}
`

export const SidebarWidthGuide = styled(ButtonUnstyled).attrs({
  tabIndex: -1,
})`
  height: 100%;
  width: 6px;
  border-right: 1px solid ${({ theme }) => theme.colors.border.A};
  position: absolute;
  right: 0;
  top: 0;
  cursor: ew-resize;
`
export const PageListWrapper = styled.div`
  padding: 8px 0;
  overflow-x: hidden;

  overflow-y: auto;
  max-height: 100%;
`
